import React, { useState } from 'react';
import { Tabs } from 'antd';
import DisplayCommunique from '../Organism/DisplayCommunique'

const Communique: React.FC = () => {
  const [activeKey, setActiveKey] = useState('1');

  const onTabChange = (key: string) => {
    setActiveKey(key);
  };

   return (
    <Tabs activeKey={activeKey} onChange={onTabChange}>
      <Tabs.TabPane tab="COE Communique" key="1">
        <DisplayCommunique />       
      </Tabs.TabPane>
    </Tabs>
  );
};

export default Communique;